// extracted by mini-css-extract-plugin
export default {"root":"AppListItem_root__GQ-lm","name":"AppListItem_name__AlZT6","clientId":"AppListItem_clientId__dvshX"};